import algeria from "../assets/images/forex/algeria.svg";
import angola from "../assets/images/forex/angola.svg";
import botswana from "../assets/images/forex/botswana.svg";
import cameroon from "../assets/images/forex/cameroon.svg";
import nigeria from "../assets/images/forex/nigeria.svg";
import uae from "../assets/images/forex/united-arab-emirates.svg";
import greatBrit from "../assets/images/forex/great-britain.svg";
import usa from "../assets/images/forex/usa.svg";
import zimbabwe from "../assets/images/forex/zimbabwe.svg";
import southAfrica from "../assets/images/forex/south-africa.svg";

export const mockTradeRates = {
  1: 0.135,
  2: 0.0193,
  3: 1.33,
  4: 0.0309,
  5: 0.0114,
  6: 4.83,
  7: 24.0,
  8: 0.055,
  9: 18.7,
};
export const beneficiaries = [
  {
    _id: "acc_001",
    name: "Zanele Khumalo",
    bank: "FNB",
    accountNumber: "62187450963784",
    branchCode: "250655",
    accountType: "Savings",
    balance: 9200.5,
    currency: "ZAR",
    createdAt: "2022-09-19T14:20:00Z",
    status: "Active",
  },
  {
    _id: "acc_002",
    name: "Sipho Mthembu",
    bank: "Standard Bank",
    accountNumber: "13799845623144",
    branchCode: "051001",
    accountType: "Cheque",
    balance: 15860.75,
    currency: "ZAR",
    createdAt: "2021-05-30T09:05:00Z",
    status: "Active",
  },
  {
    _id: "acc_003",
    name: "Lerato Molefe",
    bank: "ABSA",
    accountNumber: "78965412358962",
    branchCode: "632005",
    accountType: "Business",
    balance: 105400.0,
    currency: "ZAR",
    createdAt: "2023-08-01T11:00:00Z",
    status: "Active",
  },
  {
    _id: "acc_004",
    name: "Junaid Patel",
    bank: "Nedbank",
    accountNumber: "10023698451269",
    branchCode: "198765",
    accountType: "Savings",
    balance: 13200.1,
    currency: "ZAR",
    createdAt: "2020-12-22T16:45:00Z",
    status: "Dormant",
  },
  {
    _id: "acc_005",
    name: "Thuli Ndlovu",
    bank: "Capitec",
    accountNumber: "12895430124587",
    branchCode: "470010",
    accountType: "Savings",
    balance: 245.0,
    currency: "ZAR",
    createdAt: "2024-05-02T10:15:00Z",
    status: "Active",
  },
  {
    _id: "acc_006",
    name: "Peter van Wyk",
    bank: "Investec",
    accountNumber: "20014587412358",
    branchCode: "580105",
    accountType: "Private",
    balance: 740850.0,
    currency: "ZAR",
    createdAt: "2021-04-18T08:00:00Z",
    status: "Active",
  },
  {
    _id: "acc_007",
    name: "Khanyi Sibanda",
    bank: "TymeBank",
    accountNumber: "90765412300874",
    branchCode: "678910",
    accountType: "Savings",
    balance: 1250.6,
    currency: "ZAR",
    createdAt: "2023-11-27T13:37:00Z",
    status: "Active",
  },
  {
    _id: "acc_008",
    name: "Tshepo Radebe",
    bank: "FNB",
    accountNumber: "54123987451023",
    branchCode: "250655",
    accountType: "Cheque",
    balance: 689.1,
    currency: "ZAR",
    createdAt: "2022-02-14T12:12:00Z",
    status: "Blocked",
  },
  {
    _id: "acc_009",
    name: "Melissa Jansen",
    bank: "Standard Bank",
    accountNumber: "14005876432187",
    branchCode: "051001",
    accountType: "Business",
    balance: 58320.0,
    currency: "ZAR",
    createdAt: "2023-01-06T07:33:00Z",
    status: "Active",
  },
  {
    _id: "acc_010",
    name: "Sizwe Madikizela",
    bank: "ABSA",
    accountNumber: "85236974125874",
    branchCode: "632005",
    accountType: "Savings",
    balance: 320.45,
    currency: "ZAR",
    createdAt: "2020-08-29T15:44:00Z",
    status: "Closed",
  },
];
export const currencies = [
  {
    asset: "dzd",
    assetEstimatedPrice: "R 0.135",
    assetIcon: algeria,
    assetId: 1,
    assetName: "Algeria",
    currencySymbol: "دج", // Algerian Dinar
    availableAmount: 9639.00124806,
    availableAmountFormatted: "9639.0012480 DZD",
    type: "Crypto",
    valueInLocalCurrency: "R " + (9639.001248 * 0.135).toFixed(2),
    withdrawalFee: 2.5,
  },
  {
    asset: "aoa",
    assetEstimatedPrice: "R 0.0193",
    assetIcon: angola,
    assetId: 2,
    assetName: "Angola",
    currencySymbol: "Kz", // Angolan Kwanza
    availableAmount: 7245.13744769,
    availableAmountFormatted: "7245.13744769 AOA",
    type: "Crypto",
    valueInLocalCurrency: "R " + (7245.13744769 * 0.0193).toFixed(2),
    withdrawalFee: 5.0,
  },
  {
    asset: "bwp",
    assetEstimatedPrice: "R 1.33",
    assetIcon: botswana,
    assetId: 3,
    assetName: "Botswana",
    currencySymbol: "P", // Botswana Pula
    availableAmount: 5245.71428579,
    availableAmountFormatted: "5245.71428579 BWP",
    type: "Crypto",
    valueInLocalCurrency: "R " + (5245.71428579 * 1.33).toFixed(2),
    withdrawalFee: 0.9,
  },
  {
    asset: "xaf",
    assetEstimatedPrice: "R 0.0309",
    assetIcon: cameroon,
    assetId: 4,
    assetName: "Cameroon",
    currencySymbol: "FCFA", // Central African CFA franc
    availableAmount: 1657500.65,
    availableAmountFormatted: "1657500.65 XAF",
    type: "Crypto",
    valueInLocalCurrency: "R " + (1657500.65 * 0.0309).toFixed(2),
    withdrawalFee: 150.0,
  },
  {
    asset: "ngn",
    assetEstimatedPrice: "R 0.0114",
    assetIcon: nigeria,
    assetId: 5,
    assetName: "Nigeria",
    currencySymbol: "₦", // Nigerian Naira
    availableAmount: 1353.95764107,
    availableAmountFormatted: "1353.95764107 NGN",
    type: "Crypto",
    valueInLocalCurrency: "R " + (1353.95764107 * 0.0114).toFixed(2),
    withdrawalFee: 100.0,
  },
  {
    asset: "aed",
    assetEstimatedPrice: "R 4.83",
    assetIcon: uae,
    assetId: 6,
    assetName: "United Arab Emirates",
    currencySymbol: "د.إ", // UAE Dirham
    availableAmount: 5912.5145309,
    availableAmountFormatted: "5912.5145309 AED",
    type: "Crypto",
    valueInLocalCurrency: "R " + (5912.5145309 * 4.83).toFixed(2),
    withdrawalFee: 2.0,
  },
  {
    asset: "gbp",
    assetEstimatedPrice: "R 24.01",
    assetIcon: greatBrit,
    assetId: 7,
    assetName: "Great Britain",
    currencySymbol: "£", // British Pound
    availableAmount: 71912.519,
    availableAmountFormatted: "71912.519 GBP",
    type: "Crypto",
    valueInLocalCurrency: "R " + (71912.519 * 24.01).toFixed(2),
    withdrawalFee: 0.25,
  },
  {
    asset: "zwl",
    assetEstimatedPrice: "R 0.055",
    assetIcon: zimbabwe,
    assetId: 8,
    assetName: "Zimbabwe",
    currencySymbol: "Z$", // Zimbabwean Dollar
    availableAmount: 5712387584684.51,
    availableAmountFormatted: "5712387584684.51 ZWL",
    type: "Crypto",
    valueInLocalCurrency: "R " + (5712387584684.51 * 0.055).toFixed(2),
    withdrawalFee: 50000.0,
  },
  {
    asset: "usd",
    assetEstimatedPrice: "R 18.70",
    assetIcon: usa,
    assetId: 9,
    assetName: "United States Of America",
    currencySymbol: "$", // US Dollar
    availableAmount: 78000.51,
    availableAmountFormatted: "78000.51 USD",
    type: "Crypto",
    valueInLocalCurrency: "R " + (78000.51 * 18.7).toFixed(2),
    withdrawalFee: 1.5,
  },
];
export const userBankDetails = {
  receipient: "80eight",
  bank: "Capitec",
  accountNumber: "12345678423471",
  swift: "55441",
  branchCode: "051001",
  refCode: "8X88F19A7",
};
export const pair = [
  {
    asset: "zar",
    assetEstimatedPrice: "R 1.00",
    assetIcon: southAfrica,
    assetId: 9,
    assetName: "South Africa",
    availableAmount: 50000005451.55,
    availableAmountFormatted: "R50,000,005,451.55",
    type: "Crypto",
    valueInLocalCurrency: "R 19.18",
  },
];
